






























































import Vue from 'vue';

import AppHeaderSearchResults from '@/components/AppHeaderSearchResults.vue';

export default Vue.extend({
    components: {
        AppHeaderSearchResults,
    },
    mounted() {
        this.$search.setSearchInput(this.$refs['search-input'] as HTMLInputElement);
    },
    beforeDestroy() {
        this.$search.setSearchInput(null);
    },
});
